export const COMPANY = {
  name: "Alper Özcan",
  brand: "GaleriYönet",
  vkn: "13805174470",
  address: "Piri Reis Mahallesi Silifke Caddesi Orkide Apt Kat:3/7 Yenişehir Mersin",
  phone: "+90 546 597 61 66",
  phoneHref: "+905465976166",
  email: "info@galeriyonet.com",
  website: "https://galeriyonet.com",
};

export const PLANS_PUBLIC = [
  { key: "basic", name: "Başlangıç", price: 399, limit: "0-30 araç" },
  { key: "pro", name: "Profesyonel", price: 699, limit: "31-100 araç" },
  { key: "enterprise", name: "Kurumsal", price: 999, limit: "101+ sınırsız araç" },
];
